import type { Study } from '@pocketprep/types'
import { fetchLoadable } from '@/loadingUtils'
import { Parse } from '@/store/ParseUtils'
import { bundleModule } from '@/store/bundle/module'

const fetchBundles = async () => {
    const bundleQuery = new Parse.Query<Study.Class.Bundle>('Bundle')
        .equalTo('isDisabled', false)

    const bundlesLoadable = bundleModule.state.bundles

    return fetchLoadable(bundlesLoadable, async () => {
        const bundles = await bundleQuery.findAll()
        return bundles.reduce((acc, b) => {
            const bundleJSON = b.toJSON()
            if (bundleJSON.name === 'Finance') {
                return acc
            }
            return { ...acc, [b.id]: bundleJSON }
        }, {} as { [key: string]: Study.Class.BundleJSON })
    })
}

export default {
    fetchBundles,
}
